// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_9d-3";
export var contentContainer = "_9d-0";
export var editorContainer = "_9d-1";
export var quillInputForm = "_9d-2";
export var zoneDivider = "_9d-4";